// extracted by mini-css-extract-plugin
export default {"organizationInvitationsTable":"organization-invitations-table-container__organization-invitations-table__KtCk1"};